/**
 * 메인: 카테고리 목록
 *
 *
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Content, Title, Row, Col, Button } from 'components';
import { Empty, Flex, Tag } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { encrypt } from 'utils/Crypto';
import { dataTagErrorSymbol } from '@tanstack/react-query';

/**----------------------------------------
 * [Component] 쇼핑몰 > 메인 > 이벤트목록 컴포넌트
 * ----------------------------------------
 */
const EventList = ({
  screenSize,
  title = 'Event',
  path = '',
  data = [],
  dataKey = 'event',
  tag = 'Event',
}) => {
  /* ===== INIT ===== */
  const navigate = useNavigate();
  /* ====== 모바일인지 확인 ====== */
  const isMobile = window.ReactNativeWebView;

  /* ===== STATE ===== */
  const [selected, setSelected] = useState(null);
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  const List = React.useMemo(() => {
    if (!data.length) return [];
    /**
     * PC일 때 표기할 이벤트 리스트
     * 'ALL' && 'SHOP' (쇼핑몰)
     */
    // if (!isMobile) {
    /**
     * 웹일 경우 무조건 쇼핑몰 이벤트만 노출
     * 'ALL' && 'SHOP' (쇼핑몰)
     * -- 2025.11.10
     */
    const filterData = data.filter(
      (item) => item.type === 'SHOP' || item.type === 'ALL'
    );
    const list = filterData.slice()?.sort((a, b) => a?.order - b?.order);
    return list.slice(0, 5);
    // } else {
    //   /**
    //    * 모바일일 때 표기할 이벤트 리스트
    //    * 'ALL' && 'STORE' (매장)
    //    */
    //   const filterData = data.filter(
    //     (item) => item.type === 'STORE' || item.type === 'ALL'
    //   );
    //   const list = filterData.slice()?.sort((a, b) => a?.order - b?.order);
    //   return list.slice(0, 5);
    // }
  }, [data]);

  React.useEffect(() => {
    // 메모에서 계산한 List가 비었을 경우 Selected를 비워줌
    if (!List.length) return setSelected(null);

    setSelected(List[0]);
  }, [List]);

  // React.useEffect(() => {
  //   if (selectedStore === "" && selectedShop === "") return;

  // }, [selectedStore, selectedShop])

  /* ===== RENDER ===== */
  // JSX: start
  return (
    <Content
      maxWidth={'100%'}
      backgroundColor="none"
      padding={screenSize >= 500 ? '80px 0' : '40px 0'}
      className="eventlist"
    >
      <Content
        maxWidth={1500}
        backgroundColor="none"
        padding={0}
        style={{
          margin: '0 auto',
        }}
      >
        {/* === 타이틀 === */}
        <Title
          style={{
            fontSize: screenSize >= 768 ? 64 : screenSize >= 500 ? 30 : 26,
            marginBottom: screenSize >= 768 ? 50 : 30,
            flexWrap: 'wrap',
            gap: screenSize >= 500 ? 20 : 5,
            alignItems: 'unset',
          }}
          className="dela-gothic"
          subButton={
            <Button
              className="goto"
              onClick={() => navigate(`/${path}`)}
              type="default"
            >
              바로가기 <RightOutlined />
            </Button>
          }
        >
          {title ?? '-'}
        </Title>

        {/* === 내용: start === */}
        {selected ? (
          <Row>
            <Col x={24}>
              <Flex
                vertical={screenSize > 1024 ? false : true}
                gap={24}
                flex={'0.7 0.3'}
              >
                <Content
                  className="background_image"
                  maxWidth={1480}
                  backgroundColor="none"
                  padding={0}
                  style={{
                    margin: 0,
                    cursor: 'pointer',
                    width: '100%',
                    aspectRatio: '5 / 2.93',
                    borderRadius: 12,
                    border: '1px solid #f1f1f1',
                    background: selected
                      ? `url("${process.env.REACT_APP_STORE_URL}/${selected.thumbnail_url}") center center / cover no-repeat`
                      : '',
                    flex: 2,
                  }}
                  onClick={() =>
                    navigate(
                      `/${path}/${encodeURIComponent(
                        encrypt(selected[`${dataKey}_id`])
                      )}`
                    )
                  }
                />

                <Flex vertical gap={12} flex={1}>
                  {List.map((item, index) => (
                    <Content
                      key={`jm_${dataKey}_${item[`${dataKey}_id`]}_${index}`}
                      className="eventhover"
                      maxWidth={1480}
                      style={{
                        width: '100%',
                        // aspectRatio: '5/1.05',
                        height: 'calc((100% - 48px) / 5)',
                        borderRadius: 12,
                        border: '1px solid #f1f1f1',
                        opacity:
                          selected &&
                          selected[`${dataKey}_id`] === item[`${dataKey}_id`]
                            ? 1
                            : 0.5,
                        display: 'flex',
                        gap: screenSize >= 500 ? 5 : 0,
                        alignItems: 'center',
                        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                        flex: 'none',
                      }}
                      onClick={() => setSelected(item)}
                    >
                      <div>
                        <Tag
                          style={{
                            backgroundColor: '#671A31',
                            color: 'var(--white-color)',
                            fontSize: screenSize >= 500 ? 15 : 13,
                            border: '1px solid var(--white-color)',
                            borderRadius: 20,
                            padding: screenSize >= 500 ? '5px 10px' : '3px 7px',
                          }}
                        >
                          <span
                            style={{
                              display: screenSize >= 500 ? 'unset' : 'none',
                            }}
                          >
                            {tag}
                          </span>{' '}
                          0{index + 1}
                        </Tag>
                      </div>
                      <Title
                        align={'left'}
                        color="#515151"
                        style={{
                          alignContent: 'center',
                          alignItems: 'center',
                          fontSize: screenSize >= 500 ? 18 : 14,
                          textOverflow: 'ellipsis',
                          webkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          whiteSpace: 'nowrap',
                          fontFamily: 'Pretendard',
                        }}
                      >
                        {item[`${dataKey}_title`]}
                      </Title>
                    </Content>
                  ))}
                </Flex>
              </Flex>
            </Col>
          </Row>
        ) : (
          <Empty description={'등록된 이벤트가 없습니다.'} />
        )}
        {/* === 내용: end === */}
      </Content>
    </Content>
  ); // JSX: end
};

export default EventList;
